import { createFileRoute, Outlet } from '@tanstack/react-router'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/collection')({
  component: AdminCollectionLayout,
})

/* ───── Layout Component ───── */

function AdminCollectionLayout() {
  return <Outlet />
}
